module.exports = __webpack_public_path__ + "static/media/redux.933ef26c.png";